<template>
    <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row" v-if="userData.permissions['view_sickbay_visit']==1"> 
  
      <div class="row">
        <div class="col-12">
          <div class="card shadow-lg">
            <div class="card-body">
              <div class="clearfix"></div>
              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                      Show <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm" :options="Options"></b-form-select> entries
                    </label>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_filter" class="dataTables_filter text-md-end" >
                    <label class="d-inline-flex align-items-center">
                      Search: <b-form-input v-model="filter" type="search" placeholder="Search..." class="form-control form-control-sm ms-2"></b-form-input>
                    </label>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <b-table
                  :items="Items"
                  :fields="Fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="Filtered"
                  :busy="IsBusy"
                >
                <template #table-busy><div class="text-center text-primary my-2"><b-spinner class="align-middle" type="grow" small></b-spinner> <strong>No Data Found</strong></div></template>
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(student)="data">
                  <b class="text-danger">{{ data.item.student.first_name }} {{ data.item.student.last_name }}</b> <br> <small>{{ data.item.student.student_id }}</small>
                </template>
                <template #cell(schoolterm)="data">
                  {{ data.item.schoolterm.name }} - {{ data.item.year }} 
                </template>
                <template #cell(sickness)="data">
                  <span v-html="data.item.sickness"></span>
                </template>
                <template #cell(treatment)="data">
                  <span v-html="data.item.treatment"></span>
                </template>
                <template #cell(status)="data">
                  <span v-if="data.item.status=='1'">Sick</span>
                  <span v-else>Discharged</span>
                </template>
                <template #cell(actions)="data">
                  <div class="btn-group">
                    <b-button @click="edit(data.item.id,data.item.status)" type="button" class="btn-sm btn" variant="primary"  v-b-modal.delete> <i class="mdi mdi-square-edit-outline"></i> </b-button>
                  <!-- <b-button @click="remove(data.item.id)" type="button" class="btn-sm btn" variant="primary"  v-b-modal.delete> <i class="mdi mdi-square-edit-outline"></i> </b-button> -->
                  </div>
                </template>
                </b-table>
              </div>
              <div class="row">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-end">
                    <ul class="pagination pagination-rounded mb-0">
                      <b-pagination v-model="currentPage" :total-rows="List" :per-page="perPage"></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      

    <b-modal id="edit-visit" centered title="Edit Visit" title-class="font-18" hide-footer>
        <form @submit.prevent="editVisit">
            <input v-model="id" type="hidden">
            <div class="form-group mb-2">
              <input v-model="id" type="hidden">
              <label>status</label>
              <b-form-input v-model="status"></b-form-input>
            </div>
              <!-- Are you sure you want to delete the visit : <b>{{ visits}} </b> ? -->
            <div class="form-group d-flex justify-content-end">
                <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('edit-visit')" >Close</b-button>
                <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
            </div>
        </form>
    </b-modal>
  </div>  
  <div v-else>
    <div class="row justify-content-center">
      <div class="col-md-8 col-xl-6">
        <div>
          <center><span class="text-primary h4">You have no permission to view the Dashboard.</span></center>
          <img src="@/assets/images/profile-img.png" alt class="img-fluid" /><br><br>
        </div>
      </div>
    </div>
  </div> 
    </Layout>
  </template>
  
  <script>
  import axios from "axios";
  //import Multiselect from "vue-multiselect";
  import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import { schooltermComputed, schooltermMethods, studentComputed, studentMethods, visitsComputed, visitsMethods } from "@/state/helpers";
import Layout from "../../layouts/main";
  
  export default {
    page: {
      title: "Sickbay Visits",
      meta: [{ name: "description", content: appConfig.description,},],
    },
    components: {
      Layout,PageHeader,//Multiselect
    },
    data() {
      return {
        userData: JSON.parse(localStorage.getItem("user")),
        title: "Sickbay visits",
        items: [ {text: "Dashboard",to: "/",}, {text: "Sickbay Visits",active: true, }, ],
        TotalRows: 1,
        currentPage: 1,
        perPage: 10,
        Options: [10, 50, 100, 150, 200],
        filter: null,
        todoFilter: null,
        filterOn: [],
        sortDesc: true,
        isBusy: true,
        fields: [
            { key: 'index', label: '#', visible: true },
            { key: 'id', label: 'ID', visible: false },
            { key: 'student', label: 'Student', visible: true },
            { key: 'schoolterm', label: 'Term', visible: true },
            {key: 'visitdate',label:'Visit date', visible:true},
            {key: 'sickness',label:'Sickness',visible:true},
            {key: 'treatment',label:'Treatment',visible:true},
            {key: 'status',label:'Status',visible:true},
            {key: 'actions', label: 'Actions', visible: true },
          ],
        id:'', student:'', schoolterm:'', year:new Date().getFullYear(),sickness:'',treatment:'',visitdate:'',status:'',
        
      };
    },
    computed: {
      ...visitsComputed,
      ...schooltermComputed,
      ...studentComputed,
      List() { return this.visits.length; },
      Fields() { return this.fields.filter(field => field.visible) },
      Items() { return this.visits.map((d) => ({...d }))},
      IsBusy() { let a=false; if (this.visits.length>0) { a=false;} else { a=true;} return a },
    },
    mounted() {
      this.fetchVisits();
      this.fetchSchoolTerms();
      this.fetchStudents();
      this.TotalRows = this.visits.length;
      this.isBusy=false;
      this.schoolterm = this.schoolterms.find(option => option.active == 1);
    },
    methods: {
      ...visitsMethods,
      ...schooltermMethods,
      ...studentMethods,
      Filtered(filteredItems) {
        this.TotalRows = filteredItems.length;
        this.currentPage = 1;
      },
      edit(id,status){
        this.id=id;
        this.status=status;
        this.$bvModal.show('edit-visit')
      },
      // remove(id,student_id){
      //   this.id=id;
      //   this.student_id=student_id;
      //   this.$bvModal.show('delete-visit')
      // },
    FilterData() {
      this.filterVisits({schoolterm:this.schoolterm.id});
      this.filterStudents({schoolterm:this.schoolterm.id});
    },
      async editVisit(){ 
      let formData = new FormData();
      formData.append("id", this.id);
      let url = "/updatevisit";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
        this.fetchVisits();
        this.$bvModal.hide('edit-visit');
        this.id="";
        this.$swal({ title:'Success', text:response.data.message, icon:'success'});
        }
      });
      },
      // async removeVisit() { 
      // let formData = new FormData();
      // formData.append("id", this.id);
      // let url = "/removevisit";
      // await axios.post(url, formData).then((response) => {
      //   if (response.status == 200) {
      //     this.fetchVisits();
      //     this.$bvModal.hide('delete-visit');
      //     this.$swal({ title:'Success', text:response.data.message, icon:'success'});
      //   }
      // });
      // },
    },
  };
  </script>